exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".MenuToggle__MenuToggle--1Ffb2{\r\n position: absolute;\r\n top:40px;\r\n left:40px;\r\n font-size: 20px;   \r\n cursor: pointer;\r\n color: #fff;\r\n z-index: 100;\r\n transition: all left .2 ease-in;\r\n}\r\n\r\n\r\n.MenuToggle__MenuToggle--1Ffb2:hover{\r\n\topacity: 0.7;\r\n}\r\n\r\n.MenuToggle__MenuToggle--1Ffb2.MenuToggle__open--32P8T{\r\n\tleft:320px;\r\n}", ""]);

// exports
exports.locals = {
	"MenuToggle": "MenuToggle__MenuToggle--1Ffb2",
	"open": "MenuToggle__open--32P8T"
};